var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _path5, _rect, _rect2, _circle6, _path6, _path7, _path8, _g, _g2, _path9, _path10, _ellipse, _g3, _path11, _g4, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g6, _g7, _path21, _path22, _path23, _g8, _path24, _path25, _path26;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIHateMondays(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "i_hate_mondays_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i_hate_mondays_svg__cls-2{fill:#fa505e}.i_hate_mondays_svg__cls-3{fill:#024447}.i_hate_mondays_svg__cls-5{fill:#fff}.i_hate_mondays_svg__cls-6{fill:#fd934f}.i_hate_mondays_svg__cls-8{fill:#fed3d7}.i_hate_mondays_svg__cls-9{fill:#806b4b}.i_hate_mondays_svg__cls-10{fill:#be7f4d}.i_hate_mondays_svg__cls-11{fill:#cae0e3}.i_hate_mondays_svg__cls-12{fill:#415849}.i_hate_mondays_svg__cls-13{fill:#2a848e}.i_hate_mondays_svg__cls-14{stroke:#fa505e}.i_hate_mondays_svg__cls-14,.i_hate_mondays_svg__cls-16,.i_hate_mondays_svg__cls-17,.i_hate_mondays_svg__cls-18,.i_hate_mondays_svg__cls-19{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px}.i_hate_mondays_svg__cls-16{stroke:#006c78}.i_hate_mondays_svg__cls-17{stroke:#806b4b}.i_hate_mondays_svg__cls-18{stroke:#415849}.i_hate_mondays_svg__cls-19{stroke:#95c2c7}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-13",
    d: "M284.98 735.72v53.29c0 14.23-11.53 25.76-25.76 25.76h-6.02c-14.23 0-25.76 11.53-25.76 25.76 0 14.23 11.53 25.76 25.76 25.76h153.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-6",
    d: "M565.07 854.01h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H565.07c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-180 615.13 886.315)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-14",
    d: "M531.76 854.3l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M836.38 688.82c12.74 16.6 4.97 40.74-15.02 46.95-52.2 16.22-111.23-.63-146.44-46.53-43.94-57.27-34.6-138.65 20.17-184.59l141.29 184.16z",
    fill: "#006c78"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-9",
    cx: 810.88,
    cy: 464.28,
    r: 42.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-6",
    cx: 810.88,
    cy: 464.28,
    r: 23.87
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-9",
    cx: 955.9,
    cy: 548.01,
    r: 42.57
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-6",
    cx: 955.9,
    cy: 548.01,
    r: 23.87
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-10",
    cx: 848.87,
    cy: 565.93,
    r: 102.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-17",
    d: "M941.27 521.64c-8.61-18.01-22.57-33.69-41.17-44.43-40.61-23.45-90.61-15.93-122.64 15.23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "i_hate_mondays_svg__cls-10",
    x: 601.72,
    y: 601.25,
    width: 178.74,
    height: 73.49,
    rx: 36.75,
    ry: 36.75,
    transform: "rotate(-10.51 690.766 637.743)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "i_hate_mondays_svg__cls-10",
    x: 775.99,
    y: 701.86,
    width: 178.74,
    height: 73.49,
    rx: 36.75,
    ry: 36.75,
    transform: "rotate(-109.49 865.415 738.596)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-10",
    cx: 764.01,
    cy: 712.93,
    r: 113.76
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-6",
    d: "M797.67 632.96l18.76 10.83c22.25 12.84 50.93 5.95 64.32-15.98.25-.41.5-.83.75-1.26s.5-.89.75-1.33c10.83-19.92 3.39-44.89-16.24-56.23l-28.34-16.36c-19.63-11.33-44.96-5.3-56.8 14.03-.27.45-.54.9-.8 1.35-.25.43-.49.86-.72 1.29-12.26 22.55-3.89 50.82 18.34 63.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-12",
    d: "M842.61 594.14l22.06-6.26c10.29-2.92 12.01-16.77 2.75-22.12l-27.67-15.97c-9.26-5.35-20.4 3.07-17.78 13.44l5.61 22.23c1.67 6.62 8.47 10.54 15.04 8.68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-18",
    d: "M798.47 581.37c.49 14.11 8.01 27.67 21.14 35.25 13.13 7.58 28.63 7.32 41.1.68M841.49 578.73l-19.84 34.36"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-12",
    cx: 821.81,
    cy: 520.21,
    r: 11.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i_hate_mondays_svg__cls-12",
    cx: 902,
    cy: 566.51,
    r: 11.52
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "i_hate_mondays_svg__cls-10",
    cx: 646.2,
    cy: 747.05,
    rx: 69.55,
    ry: 57.69,
    transform: "rotate(-60 646.202 747.046)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i_hate_mondays_svg__cls-6",
    cx: 630.18,
    cy: 758.48,
    rx: 32.71,
    ry: 39.43,
    transform: "rotate(-.18 613.183 736.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i_hate_mondays_svg__cls-10",
    cx: 793.36,
    cy: 832.01,
    rx: 69.55,
    ry: 57.69,
    transform: "rotate(-60 793.357 832.006)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i_hate_mondays_svg__cls-6",
    cx: 791.47,
    cy: 851.6,
    rx: 39.43,
    ry: 32.71,
    transform: "rotate(-29.82 791.629 851.695)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-17",
    d: "M719.35 678.88c19.21-3.71 40.85-.37 60.39 10.91 19.53 11.28 33.25 28.35 39.64 46.84"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-13",
    d: "M721.67 424.64v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H384.14c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V424.64c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "i_hate_mondays_svg__cls-13",
    cx: 546.35,
    cy: 237.64,
    rx: 103.96,
    ry: 51.38
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-6",
    d: "M368.95 854.01h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H368.95c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(180 419.01 886.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-14",
    d: "M337.64 854.3l-1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-5",
    d: "M661.67 750.7V598.93c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76V750.7c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-2",
    d: "M503.07 702.97c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM594.74 702.97c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f93444",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "M497.27 659.02h103.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i_hate_mondays_svg__cls-2",
    x: 530.74,
    y: 640.86,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.06 640.86c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#f93444"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-5",
    d: "M522.15 415.51v49.26c0 4.75-.56 9.37-1.63 13.81-6.27 26.11-29.87 45.66-57.83 45.66s-51.56-19.55-57.83-45.66a58.854 58.854 0 01-1.63-13.81v-49.26c0-32.71 26.76-59.46 59.46-59.46 16.36 0 31.22 6.69 42 17.46 10.77 10.78 17.46 25.65 17.46 42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-8",
    d: "M522.15 415.51v49.26c0 4.75-.56 9.37-1.63 13.81-19.19 5.84-38.58 8.79-57.83 8.79s-38.64-2.95-57.83-8.79a58.854 58.854 0 01-1.63-13.81v-49.26c0-32.71 26.76-59.46 59.46-59.46 16.36 0 31.22 6.69 42 17.46 10.77 10.78 17.46 25.65 17.46 42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M509.14 501.79c-10.92 13.66-27.71 22.44-46.45 22.44-19.58 0-37.03-9.59-47.88-24.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M403.91 530.23c13.6 6.83 29.28 9.45 44.36 7.41 15.08-2.04 29.5-8.73 40.8-18.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-3",
    d: "M472.69 494.23c-16.25 0-29.46-13.22-29.46-29.46v-49.26c0-16.25 13.22-29.46 29.46-29.46s29.46 13.22 29.46 29.46v49.26c0 16.25-13.22 29.46-29.46 29.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-13",
    d: "M527.08 444.51V416.4c0-35.41-28.97-64.39-64.39-64.39-35.41 0-64.39 28.97-64.39 64.39v28.11c42.93 17.14 85.85 17.14 128.77 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M508.17 370.93c-11.67-11.67-27.77-18.91-45.47-18.91-17.71 0-33.8 7.24-45.47 18.91-11.67 11.67-18.91 27.77-18.91 45.47M398.31 444.51c42.93 17.14 85.85 17.14 128.77 0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-5",
    d: "M676.63 409.56v61.16c0 3.19-.28 6.32-.83 9.36-4.45 25.01-26.44 44.16-52.69 44.16s-48.24-19.15-52.69-44.17c-.55-3.04-.83-6.16-.83-9.35v-61.16c0-29.43 24.09-53.51 53.52-53.51 14.72 0 28.1 6.02 37.8 15.72 9.7 9.7 15.72 23.07 15.72 37.79z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-8",
    d: "M676.63 409.56v61.16c0 3.19-.28 6.32-.83 9.36-17.51 4.84-35.15 7.29-52.69 7.29s-35.18-2.45-52.69-7.3c-.55-3.04-.83-6.16-.83-9.35v-61.16c0-29.43 24.09-53.51 53.52-53.51 14.72 0 28.1 6.02 37.8 15.72 9.7 9.7 15.72 23.07 15.72 37.79z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M581.84 504.75c10.91 12.28 26.81 20.05 44.43 20.05 19.58 0 37.03-9.59 47.88-24.31"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M685.06 530.8c-13.6 6.83-29.28 9.45-44.36 7.41-15.08-2.04-29.5-8.73-40.8-18.92"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-3",
    d: "M628.94 494.23c-14.62 0-26.52-13.22-26.52-29.46v-49.26c0-16.25 11.9-29.46 26.52-29.46s26.52 13.22 26.52 29.46v49.26c0 16.25-11.9 29.46-26.52 29.46z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-13",
    d: "M687.5 444.51V416.4c0-35.41-28.97-64.39-64.39-64.39-35.41 0-64.39 28.97-64.39 64.39v28.11c42.93 17.14 85.85 17.14 128.77 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-11",
    d: "M177.67 795.69l57.55-62.35h94.26c23.17 0 38.68 23.83 29.29 45.02l-48.9 110.37a52.303 52.303 0 01-47.82 31.12H53.88c-37.93 0-63.25-39.12-47.72-73.72 8.19-18.25 26.08-30.23 46.08-30.86l88.63-2.77a52.322 52.322 0 0036.8-16.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-19",
    d: "M329.48 733.35c23.17 0 38.68 23.83 29.29 45.02l-48.9 110.37a52.303 52.303 0 01-47.82 31.12c-21.65 0-43.14-3.69-63.56-10.91l-41.46-14.67a190.568 190.568 0 00-63.56-10.91H70.59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-19",
    d: "M163.86 806.8c18.36 5.41 38.4 4.92 56.47-1.38s34.08-18.38 45.1-34.02"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-13",
    d: "M196.23 738.25c-7.22 19.65 7.4 40.37 28.32 40.35 54.66-.06 105.99-33.73 125.94-88.03 24.89-67.76-8.27-142.66-74.24-170.2l-80.02 217.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M224.55 778.6c54.66-.06 105.99-33.73 125.94-88.03"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M668.59 370.93c-11.67-11.67-27.77-18.91-45.47-18.91-17.71 0-33.8 7.24-45.47 18.91-11.67 11.67-18.91 27.77-18.91 45.47M558.73 444.51c42.93 17.14 85.85 17.14 128.77 0"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-11",
    d: "M524.01 187.69s-34.89 9.11-81.51 43.1c-8.69 6.33-17.79 13.54-27.16 21.72C366.66 295 311.02 363.68 269.52 472.93c-2.27 5.98-10.32 7.02-14 1.79-6.24-8.88-14.59-24.75-21.95-52.14 0 0-7.78 28.6-47.22 39.26-16.29 4.4-32.34-7.83-32.34-24.71 0-3.32.64-6.58 1.86-9.6 1.21-3.03 3.01-5.81 5.33-8.19 10.91-11.17 28.8-39.03 12.81-92.82-.39-1.32-.77-2.64-1.15-3.97-32.01-113.13 74.26-216.87 186.99-183.48l164.16 48.62z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-19",
    d: "M172.86 322.54c-32.01-113.13 74.26-216.87 186.99-183.48l109.79 32.52"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-16",
    d: "M547.86 251.16c19.28 11.45 42.03 16.98 64.42 15.64 10.83-.65 22.2-3.18 30.02-10.7s10.43-21.21 3.14-29.25M499.44 269.64c16.43 12.99 37.24 20.36 58.19 20.6s41.92-6.65 58.64-19.27"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-5",
    d: "M322.62 310.48v-.03c.01-10.02 4.5-19.96 12.01-26.6 1.16-1.03 2.41-2 3.29-3.28s1.32-2.98.71-4.4c-.99-2.27-3.99-2.74-6.46-2.62-8.22.4-16.27 3.67-22.44 9.11-14.5 12.79-15.68 34.69-4.09 49.85 6.16 8.06 15.6 13.53 25.65 14.88 2.81.38 6.38 0 7.4-2.64 1.12-2.9-1.78-5.62-4.11-7.69-7.49-6.64-11.96-16.58-11.96-26.59zM382.12 158.43l2.67 8.22a3.996 3.996 0 003.8 2.76h8.65c3.87 0 5.49 4.96 2.35 7.24l-7 5.08a3.991 3.991 0 00-1.45 4.47l2.67 8.22c1.2 3.69-3.02 6.75-6.16 4.47l-7-5.08a3.992 3.992 0 00-4.7 0l-7 5.08c-3.13 2.28-7.35-.79-6.16-4.47l2.67-8.22c.54-1.65-.05-3.45-1.45-4.47l-7-5.08c-3.13-2.28-1.52-7.24 2.35-7.24h8.65a4 4 0 003.8-2.76l2.67-8.22c1.2-3.69 6.41-3.69 7.61 0zM289.98 195.84v-.03c.01-10.02 4.5-19.96 12.01-26.6 1.16-1.03 2.41-2 3.29-3.28s1.32-2.98.71-4.4c-.99-2.27-3.99-2.74-6.46-2.62-8.22.4-16.27 3.67-22.44 9.11-14.5 12.79-15.68 34.69-4.09 49.85 6.16 8.06 15.6 13.53 25.65 14.88 2.81.38 6.38 0 7.4-2.64 1.12-2.9-1.78-5.62-4.11-7.69-7.49-6.64-11.96-16.58-11.96-26.59zM454.57 215.54c-.87 1.28-2.12 2.25-3.28 3.28-3.75 3.31-6.74 7.43-8.79 11.97-8.69 6.33-17.79 13.54-27.16 21.72-2.76-12.46.86-25.92 11.03-34.88 6.17-5.44 14.23-8.71 22.45-9.11 2.47-.12 5.47.34 6.46 2.62.62 1.42.17 3.12-.71 4.4zM215.99 374.93v-.03c.01-10.02 4.5-19.96 12.01-26.6 1.16-1.03 2.41-2 3.29-3.28s1.32-2.98.71-4.4c-.99-2.27-3.99-2.74-6.46-2.62-8.22.4-16.27 3.67-22.44 9.11-14.5 12.79-15.68 34.69-4.09 49.85 6.16 8.06 15.6 13.53 25.65 14.88 2.81.38 6.38 0 7.4-2.64 1.12-2.9-1.78-5.62-4.11-7.69-7.49-6.64-11.96-16.58-11.96-26.59zM236.1 252.86l2.67 8.22a3.996 3.996 0 003.8 2.76h8.65c3.87 0 5.49 4.96 2.35 7.24l-7 5.08a3.991 3.991 0 00-1.45 4.47l2.67 8.22c1.2 3.69-3.02 6.75-6.16 4.47l-7-5.08a3.992 3.992 0 00-4.7 0l-7 5.08c-3.13 2.28-7.35-.79-6.16-4.47l2.67-8.22c.54-1.65-.05-3.45-1.45-4.47l-7-5.08c-3.13-2.28-1.52-7.24 2.35-7.24h8.65a4 4 0 003.8-2.76l2.67-8.22c1.2-3.69 6.41-3.69 7.61 0zM281.98 373.28l2.67 8.22a3.996 3.996 0 003.8 2.76h8.65c3.87 0 5.49 4.96 2.35 7.24l-7 5.08a3.991 3.991 0 00-1.45 4.47l2.67 8.22c1.2 3.69-3.02 6.75-6.16 4.47l-7-5.08a3.992 3.992 0 00-4.7 0l-7 5.08c-3.13 2.28-7.35-.79-6.16-4.47l2.67-8.22c.54-1.65-.05-3.45-1.45-4.47l-7-5.08c-3.13-2.28-1.52-7.24 2.35-7.24h8.65a4 4 0 003.8-2.76l2.67-8.22c1.2-3.69 6.41-3.69 7.61 0z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-19",
    d: "M386.72 279.94c-40.88 42.89-83.66 104.69-117.19 192.99-2.27 5.98-10.32 7.02-14 1.79-4.98-7.08-19.97-34.16-29.66-83.64M8.29 844.76c4.5-13.32 17.56-22.49 31.34-25.31 13.77-2.82 28.12-.16 41.47 4.27 13.34 4.43 26.05 10.59 39.38 15.06 44.11 14.79 94.5 9.63 134.7-13.79"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "i_hate_mondays_svg__cls-6",
    d: "M494.23 504.18c.17 26.74 22.09 48.56 48.86 48.56s48.69-21.82 48.86-48.56h-97.73z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M578.71 520.94c-19.17-4.07-35.45-4.09-54.7 0-10.48 2.77-22.85-.48-28.55-10.26-5.41-12.54 5.84-25.58 17.94-28.29 26.36-6.04 49.55-6.04 75.91 0 11.9 3.69 23.58 15.08 17.94 28.29-5.7 9.78-18.06 13.03-28.55 10.26z",
    fill: "#fed425"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHateMondays);
export default ForwardRef;